import React, { useEffect, useState } from 'react';
import { Grid, TextField, FormControl, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Autocomplete } from '@mui/material';
import classNames from 'classnames';
import { getEndDate, getStartDate } from '../../util/date';
import { fromSessionStorage,toSessionStorage } from '../../util/storage';
// import AdjustIcon from '@materialui/icons/Adjust';

const useStyles = makeStyles(theme => ({
    formControl: {
        width: '200px',
        '@media (max-width: 1500px)': {
            width: '150px',
        },
        marginTop: 2,
    },
    icon: {
        fontSize: '10px',
        color: '#C8C8C8',
    },
    container: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    }
}));

export default function SelectSearchTitle({ 
    searchFilters = [], 
    pending,
    selectedPtr,
    showSearchCriteriaDropdown = true,
    disabled = false,
}) {
    const classes = useStyles();
    
    function handleChange(event, value) {
        selectedPtr.set(value?.id);
    }

    return (<>
        {showSearchCriteriaDropdown &&
        <Grid container>
            <Grid item xs={10}>
                <Grid container className={classes.container}>
                    {/* <Grid item xs={12}>{title}</Grid> */}
                    <Grid item xs={12}>
                        <FormControl className={classes.formControl}>
                            <Autocomplete
                                disableClearable
                                disablePortal
                                disabled={pending || disabled}
                                onChange={handleChange}
                                value={ searchFilters?.find((x) => x.id === selectedPtr.value) || {} }
                                options={searchFilters || []}
                                className={classes.formControl}
                                getOptionLabel={(option) => option?.criteriaName || ''}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                renderInput={(params) => (
                                    <TextField {...params}
                                        name="criteria"
                                        label='Default Search Criteria'
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <Grid container>
                                            <Grid item xs={11}>
                                                {option.criteriaName}
                                            </Grid>
                                            {option.isPublic && (
                                                <Grid item xs={1}>
                                                    <Tooltip title="Public">
                                                        <i className={classNames("fa fa-user-friends", classes.icon)}></i>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </li>
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        }
    </>);
}
